import { PropTypes } from "prop-types"
import classNames from "classnames"

import InputDate from "./InputDate"
import Field from "../Field"
import fieldSchemaPropTypes from "../fieldSchemaPropTypes"
import errorPropTypes from "../errorPropTypes"

export function DateField(props) {
  const { className, error, id, label, schema = {}, touched = false, ...rest } = props
  return (
    <Field className={classNames("oj-date-field", className)} touched={touched} error={error}>
      <Field.Label inputId={id} label={label} required={schema.required}>
        <Field.Input {...schema} {...rest} id={id} error={error}>
          {innerProps => <InputDate {...innerProps} />}
        </Field.Input>
      </Field.Label>
    </Field>
  )
}

DateField.propTypes = {
  className: PropTypes.string,
  error: PropTypes.shape(errorPropTypes),
  id: PropTypes.string,
  label: PropTypes.node,
  schema: PropTypes.shape(fieldSchemaPropTypes),
  touched: PropTypes.bool
}

export default DateField
